import { render, staticRenderFns } from "./KioskModeView.vue?vue&type=template&id=3a9522b2&scoped=true&"
import script from "./KioskModeView.vue?vue&type=script&lang=ts&"
export * from "./KioskModeView.vue?vue&type=script&lang=ts&"
import style0 from "./KioskModeView.vue?vue&type=style&index=0&id=3a9522b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9522b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a9522b2')) {
      api.createRecord('3a9522b2', component.options)
    } else {
      api.reload('3a9522b2', component.options)
    }
    module.hot.accept("./KioskModeView.vue?vue&type=template&id=3a9522b2&scoped=true&", function () {
      api.rerender('3a9522b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/KioskModeView.vue"
export default component.exports